import React from 'react'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { getFormattedNumber } from '../../../../../../../../common/utils'
import FiberSetReferencePowerStatus from '../fibersetreferencepowerstatus'

class FiberSetReferencePowerTable extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      setreference,
      translate,
      classes,
    } = this.props

    const powerData = setreference.power.map((n, k) => {
      let direction
      if (n.fibredir === 'RemoteToMain') {
        direction = translate('fiber_remote_to_main')
      } else if (n.fibredir === 'MainToRemote') {
        direction = translate('fiber_main_to_remote')
      } else if (n.fibredir === 'MainToMain') {
        direction = translate('fiber_main_to_main')
      }

      return {
        fibreno: n.fibreno,
        direction,
        wavelength: n.wavelength,
        refpower: n.refpower,
        limitmin: n.limitmin,
        limitmax: n.limitmax,
        result: n.result
      }
    }).sort((a, b) => (a.fibreno - b.fibreno || a.wavelength - b.wavelength))

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{translate('fiber_n')}</TableCell>
            <TableCell>{translate('fiber_test_direction')}</TableCell>
            <TableCell numeric>{translate('fiber_wavelength')}</TableCell>
            <TableCell numeric>{translate('fiber_setreference_refpower')}</TableCell>
            <TableCell numeric>{translate('fiber_setreference_limit')}</TableCell>
            <TableCell numeric>{translate('fiber_result')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            (powerData && powerData.length) ? (powerData.map((item, k) => {
              return (<TableRow key={k}>
                <TableCell component="th" scope="row" style={{color: item.fibreno == 2 ? '#FBA71A' : '#24418F'}}>{translate('general_fiber')} {item.fibreno}</TableCell>
                <TableCell>{item.direction}</TableCell>
                <TableCell numeric>{parseFloat(getFormattedNumber(item.wavelength))}</TableCell>
                <TableCell numeric>{parseFloat(getFormattedNumber(item.refpower))}</TableCell>
                <TableCell numeric> &gt; {item.limitmin}</TableCell>
                <TableCell numeric>{item.result ? (<React.Fragment><FiberSetReferencePowerStatus status={item.result} /></React.Fragment>) : (translate('general_na'))}</TableCell>
              </TableRow>)
            })) : null}
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(FiberSetReferencePowerTable)

